import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { ApiService } from 'src/app/api.service';
import { AuthenticationService } from 'src/app/_services';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { IntItemSalesHdrVO } from 'src/app/shared/models/IntItemSalesHdrVO';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';

@Component({
  selector: 'app-tracing-grant-audios',
  templateUrl: './tracing-grant-audios.component.html',
  styleUrls: ['./tracing-grant-audios.component.scss'],
  providers: [MessageService, ConfirmationService, DecimalPipe]
})
export class TracingGrantAudiosComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT EXPORT*/
  blocked: boolean = true;

  /** PIPES */
  datePipe: DatePipe = new DatePipe("en-US");

  /** LABELS */
  translations: Record<string, string> = {};
  title : string = "";
  storesTracing: any[];
  stackedStores : string[] = [];
  itemCat2 : string;

  columns:any = [
    {header: "lbl_id", field: "storeId"},
    {header: "lbl_name", field: "storeName"},
    {header: "Total Items con acceso GRP", field: "qtyGRP"},
    {header: "Importe GRP", field: "amountGRP"},
    {header: "Total Guias Con Cargo CXC3", field: "qtyCXC3"},
    {header: "Importe CXC3", field: "amountCXC3"},
    {header: "Importe DIE", field: "amountDIE"},
  ];

  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private decimalPipe: DecimalPipe,
    private tovpilUtils: TovpilUtilsService,
    private userPreferencesService: UserPreferencesService,
    private fb: FormBuilder,
    private router: Router,
    private translationService: TovpilLanguageService,
    private filesService: TovpilFilesService
  ) {
    this.createDataForm();
    this.initConfigs();

    if (this.globalUserDataForm.get("token").value) {
      if (
        this.globalUserDataForm.get("device").value &&
        this.globalUserDataForm.get("device").value == "2"
      ) {
        this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
      }
    } else {
      this.globalUserDataForm.patchValue({
        currentUser: this.authenticationService.currentUserValue,
      });
    }
  }

  /**
  * The function initializes form groups for configuration and data, and updates the configuration form
  * with query parameters from the route.
  */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
    //console.debug("COORDS - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
   * The function `createDataForm` in TypeScript initializes a form group with various form controls and
   * default values, as well as setting some controls as disabled.
   */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      // SECURITY
      token: [null],
      device: [null],
      storeId: [null],
      security: [null],
      currentUser: [null],
      stackedStores:  [null],
    });
  }

  ngOnInit(): void {
    // console.debug("Fire ngInit");
    this.route.queryParams.subscribe(params => {
      this.itemCat2 = params.itemCat2;
    });
    this.getSecurity();
    this.getInitData();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            console.error(
              "Autenticación",
              "Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde."
            );
          }
        },
        (error) => {
          console.error(
            "Autenticación",
            "Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde."
          );
        }
      );
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    console.debug('getSecurity');
    const security = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!security) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }
    await this.getTranslatedLabels();
  }


  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    // this.blocked = true;
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.title= this.translations.lbl_following_up + " " + this.translations.lbl_grant + " " + this.translations.lbl_play_audio;
      await this.translateCols();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
    // this.blocked = false;
  }

  /**
  * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
  * and then updates the form with the fetched data.
  */
  async getInitData() {
    // console.debug("Init data");
    let storeId = this.globalUserPreferences.preferences.storeId;
    // let storeId = '0000000002';
    this.stackedStores.push(storeId);
    // console.debug(this.stackedStores);
    await this.getData(storeId);
  }

  async getData(store){
    // this.blocked = true;
    let storeId = store;
    let value = this.itemCat2;
    let request = {
      storeId: storeId,
      value : value
    };
    try {
      let data: IntItemSalesHdrVO[] = await this.apiService.getInternatItemsSalesByCategory(request);
      let mappedData = data.map( e => ({
        ...e,
        amountCXC3 : this.formatAmount(e.amountCXC3),
        amountGRP :  this.formatAmount(e.amountGRP),
        amountDIE : this.formatAmount(e.amountDIE)
      }));

      this.storesTracing = mappedData;
      this.blocked = false;
    } catch (error) {
      console.error(
        "An error occurred while fetching Local Coords list:",
        error
      );
    }
  }

  formatAmount(value){
    let language = this.globalUserPreferences.preferences.language;
    let region = this.globalUserPreferences.preferences.region;
    let format = region == 'MX' ? 'en-US' : 'es-ES';
    let res = value != null && value != 0 ? this.decimalPipe.transform(value, '1.2-2', format) : '.00';
    // if(region == 'MX'){
    //   res = res + " MXN";
    // }
    // else{
    //   res = res + " EUR";
    // }
    return res ;
  }

  translateCols() {
    const translateFGdCols = this.columns.map((e) => ({
      ...e,
      header: this.translations[e.header] != null ? this.translations[e.header] : e.header,
    }));

    translateFGdCols[2].header = `${this.translations.lbl_total} ${this.translations.lbl_items} con acceso GRP`; // Items GRP
    translateFGdCols[3].header = `${this.translations.lbl_amount} GRP`; 
    translateFGdCols[4].header = `${this.translations.lbl_total} ${this.translations.lbl_guides} Con Cargo ${this.translations.lbl_cxc}3`; // Guias cargo CXC
    translateFGdCols[5].header = `${this.translations.lbl_amount} ${this.translations.lbl_cxc}3`; 
    translateFGdCols[6].header = `${this.translations.lbl_amount} ${this.translations.lbl_die}`; 

    this.columns = translateFGdCols;
  }

  navigateAhead(storeId){
    this.stackedStores.push(storeId);
    console.debug(this.stackedStores);
    this.getData(this.stackedStores[this.stackedStores.length-1]);
  }

  async navigateBack(){
    console.debug(this.stackedStores);
    if(this.stackedStores.length == 1){
      // this.router.navigate(['/']); Para uso solo respo
      window.close(); // Para uso con monolitico
    }
    else {
      this.stackedStores.pop()
      await this.getData(this.stackedStores[this.stackedStores.length-1]);
    }
  }

  exportExcel() {
    if (this.storesTracing === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.storesTracing.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.storesTracing.map((item) => ({
        [this.translations.lbl_id]: item.storeId || '0',
        [this.translations.lbl_name]: item.storeName || '0',
        "Total Guias con Acceso GRP": item.qtyGRP || '0',
        "Importe GRP": item.amountGRP || '0',
        "Total Guias Con Cargo CXC3": item.qtyCXC3 || '0',
        "Importe CXC3": item.amountCXC3 || '0',
        "Importe DIE": item.amountDIE || '0',
      }));
      this.filesService.tovpilExportXLSX(filteredJSON, 'tracingGrantAudios_');
    }
  }

  exportPdf() {
    if (this.storesTracing === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.storesTracing.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.storesTracing.map((item) => ({
        [this.translations.lbl_id]: item.storeId || '0',
        [this.translations.lbl_name]: item.storeName || '0',
        "Total Guias con Acceso GRP": item.qtyGRP || '0',
        "Importe GRP": item.amountGRP || '0',
        "Total Guias Con Cargo CXC3": item.qtyCXC3 || '0',
        "Importe CXC3": item.amountCXC3 || '0',
        "Importe DIE": item.amountDIE || '0',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listStoredPeriod_');
    }
  }
}

